import { create } from 'zustand'

import type { SubscriptionStatus } from '@/types/enums'

interface SubscriptionError {
  type: 'quota-exceeded' | 'subscription-expired' | 'resource-locked'
  message: string
}

interface SubscriptionState {
  status: SubscriptionStatus | null
  cancelAtPeriodEnd: boolean
  lockedResourceIds: Set<string>
  currentPeriodEnd: Date | null
  error: SubscriptionError | null

  setStatus: (status: SubscriptionStatus | null) => void
  setCancelAtPeriodEnd: (cancelAtPeriodEnd: boolean) => void
  setLockedResourceIds: (ids: Set<string>) => void
  setCurrentPeriodEnd: (date: Date | null) => void
  setSubscriptionError: (type: SubscriptionError['type'], message: string) => void
  clearError: () => void
  clear: () => void
}

export const useSubscriptionStore = create<SubscriptionState>((set) => ({
  status: null,
  cancelAtPeriodEnd: false,
  lockedResourceIds: new Set(),
  currentPeriodEnd: null,
  error: null,

  setStatus: (status) => set({ status }),
  setCancelAtPeriodEnd: (cancelAtPeriodEnd) => set({ cancelAtPeriodEnd }),
  setLockedResourceIds: (lockedResourceIds) => set({ lockedResourceIds }),
  setCurrentPeriodEnd: (currentPeriodEnd) => set({ currentPeriodEnd }),
  setSubscriptionError: (type, message) =>
    set({ error: { type, message } }),
  clearError: () => set({ error: null }),
  clear: () =>
    set({
      status: null,
      cancelAtPeriodEnd: false,
      lockedResourceIds: new Set(),
      currentPeriodEnd: null,
      error: null,
    }),
}))